import API from "@/utils/Api";
import { get } from "@/context/context";
import {AxiosResponse} from "axios";
import {TeacherRepository} from "@/repositories/TeacherRepository";
import {Teacher} from "@/models/Teacher/Teacher";
import {TeacherRequest} from "@/models/Teacher/TeacherRequest";
import {RequestConfig} from "@/models/RequestConfig";

export class TeacherApi implements TeacherRepository {

    private api: API = get('api');

    public async getList(): Promise<Teacher[]> {
        const response: AxiosResponse<Teacher[]> =
            await this.api.get('/uploader/wix/teacher');
        const { data } = response;
        return data || [];
    }

    public async getListByStyle(styleId:string): Promise<Teacher[]> {
        const response: AxiosResponse<Teacher[]> =
            await this.api.get('/uploader/wix/teacher?style='+styleId);
        const { data } = response;
        return data || [];
    }

    public async create(payload: TeacherRequest, config?: RequestConfig): Promise<Teacher> {
        //TODO fix
        const response: AxiosResponse<Teacher> =
            await this.api.post('', payload, config);
        const { data } = response;
        return data || null;
    }

    public async edit(payload: TeacherRequest, config?: RequestConfig): Promise<Teacher> {
        //TODO fix
        const response: AxiosResponse<Teacher> =
            await this.api.post('', payload, config);
        const { data } = response;
        return data || null;
    }

    public async delete(id: string, config?: RequestConfig): Promise<void> {
        //TODO fix
        const response: AxiosResponse<void> =
            await this.api.post('', {id}, config);
        const { data } = response;
    }
}
